import type { HomePageVariant } from '@/interface/home-pages';

export const HOME_PAGES_V3 = { key: 'home-v3', cta: 'teste', visual: 'v23' } as const satisfies HomePageVariant;
